var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ai-check-container" },
    [
      _c("div", { staticClass: "ai-header-banner" }, [
        _c("div", { staticClass: "banner-overlay" }),
        _c("div", { staticClass: "banner-content" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "banner-actions flex gap-2" },
            [
              _c(
                "el-button",
                {
                  staticClass: "gradient-btn green-btn",
                  attrs: { type: "success", icon: "el-icon-plus" },
                  on: { click: _vm.handleAddCard },
                },
                [_vm._v("\n          Thêm thẻ mới\n        ")]
              ),
              _c(
                "el-dropdown",
                {
                  staticClass: "modern-dropdown-wrapper",
                  on: { command: _vm.handleCommand },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "gradient-btn purple-btn",
                      attrs: { type: "warning" },
                    },
                    [
                      _vm._v("\n            Tác vụ hàng loạt "),
                      _c("i", {
                        staticClass: "el-icon-arrow-down el-icon--right",
                      }),
                    ]
                  ),
                  _c(
                    "el-dropdown-menu",
                    {
                      staticClass: "modern-dropdown-menu",
                      attrs: { slot: "dropdown" },
                      slot: "dropdown",
                    },
                    [
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            command: "activeCard",
                            icon: "el-icon-circle-check",
                          },
                        },
                        [_vm._v("Kích hoạt thẻ đã chọn")]
                      ),
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            command: "disableCard",
                            icon: "el-icon-circle-close",
                          },
                        },
                        [_vm._v("Hủy kích hoạt đã chọn")]
                      ),
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            command: "deleteCards",
                            icon: "el-icon-delete",
                          },
                        },
                        [_vm._v("Xóa thẻ đã chọn")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "ai-stats-grid" }, [
        _c("div", { staticClass: "stat-card blue" }, [
          _vm._m(1),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [_vm._v("Tổng số thẻ")]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.totalRecords)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "stat-card green" }, [
          _vm._m(2),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [
              _vm._v("Thẻ đang hoạt động (trang này)"),
            ]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.stats.activeCount)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "stat-card purple" }, [
          _vm._m(3),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [
              _vm._v("Thẻ chưa gán sử dụng (trang này)"),
            ]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.stats.unusedCount)),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "glass-card mb-4" },
        [
          _c(
            "el-form",
            {
              staticClass: "modern-filter-form",
              attrs: { inline: true, model: _vm.dataFilter },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Trường học" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "modern-select",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "Tất cả các trường",
                      },
                      on: { change: _vm.searchInformationCard },
                      model: {
                        value: _vm.dataFilter.idSchool,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataFilter, "idSchool", $$v)
                        },
                        expression: "dataFilter.idSchool",
                      },
                    },
                    _vm._l(_vm.schoolList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          value: item.id,
                          label: `${item.id} - ${item.schoolName}`,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Trạng thái sử dụng" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "modern-select",
                      attrs: {
                        clearable: "",
                        placeholder: "Tất cả trạng thái",
                      },
                      on: { change: _vm.searchInformationCard },
                      model: {
                        value: _vm.dataFilter.usageStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataFilter, "usageStatus", $$v)
                        },
                        expression: "dataFilter.usageStatus",
                      },
                    },
                    _vm._l(_vm.listUsageStatus, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { value: item.value, label: item.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Số thẻ" } },
                [
                  _c("el-input", {
                    staticClass: "modern-input",
                    attrs: {
                      clearable: "",
                      placeholder: "Nhập số thẻ...",
                      "prefix-icon": "el-icon-search",
                    },
                    on: { clear: _vm.searchInformationCard },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.searchInformationCard.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.dataFilter.cardNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataFilter, "cardNumber", $$v)
                      },
                      expression: "dataFilter.cardNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "filter-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.searchInformationCard },
                    },
                    [_vm._v("Tìm kiếm")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "glass-card table-container" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading.table,
                  expression: "loading.table",
                },
              ],
              ref: "multipleTable",
              staticClass: "modern-table",
              attrs: {
                data: _vm.dataTable,
                "element-loading-text": "Đang tải danh sách thẻ nhận diện...",
                "element-loading-spinner": "el-icon-loading",
                "element-loading-background": "rgba(255,255,255,0.7)",
                border: "",
                "highlight-current-row": "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55", align: "center" },
              }),
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  index: _vm.calculateStt,
                  label: "STT",
                  width: "55",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "Số thẻ", "min-width": "200", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "card-number-badge" }, [
                          _c("i", { staticClass: "el-icon-bank-card" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(row.cardNumber) +
                              "\n          "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Trạng thái sử dụng",
                  "min-width": "180",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            staticClass: "status-tag-rect",
                            attrs: {
                              type: _vm.getUsageStatusTagType(row.usageStatus),
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.getUsageStatusLabel(row.usageStatus)
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tên trường học",
                  "min-width": "300",
                  align: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "school-name-text" }, [
                          _c("i", {
                            staticClass: "el-icon-school",
                            staticStyle: {
                              color: "#64748b",
                              "margin-right": "6px",
                            },
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(row.schoolName || "—") +
                              "\n          "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tác vụ",
                  width: "340",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "success",
                              icon: "el-icon-check",
                              disabled: row.usageStatus !== "delete",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.activeCard(row)
                              },
                            },
                          },
                          [_vm._v("Kích hoạt\n          ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "warning",
                              icon: "el-icon-close",
                              disabled: row.usageStatus === "delete",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deActiveCard(row)
                              },
                            },
                          },
                          [_vm._v("Hủy kích hoạt\n          ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "danger",
                              icon: "el-icon-delete",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deleteCard(row)
                              },
                            },
                          },
                          [_vm._v("Xóa\n          ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.dataFilter.page,
                  "page-sizes": _vm.pageListDefaultCardOneAdmin,
                  "page-size": _vm.dataFilter.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.totalRecords,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentPageChange,
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.dataFilter, "page", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.dataFilter, "page", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("AddCardDialog", {
        attrs: { "is-open": _vm.isOpen.add, schoolList: _vm.schoolList },
        on: { closeDialog: _vm.handleCloseDialogAdd },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "banner-left" }, [
      _c("div", { staticClass: "ai-icon-pulse" }, [
        _c("i", { staticClass: "el-icon-bank-card" }),
      ]),
      _c("div", [
        _c("h1", { staticClass: "banner-title" }, [
          _vm._v("QUẢN LÝ THẺ NHẬN DIỆN AI"),
        ]),
        _c("p", { staticClass: "banner-subtitle" }, [
          _vm._v(
            "Quản lý danh sách thẻ từ, trạng thái kích hoạt, gán trường học và thực hiện tác vụ hàng loạt."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-folder-opened" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-circle-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-circle-close" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }